import { CaseChatButtonView } from "./CaseChatButtonView";

export interface CaseChatButtonProps {
  onClick: () => void;
}

export const CaseChatButton: React.FC<CaseChatButtonProps> = ({ onClick }) => {
  return <CaseChatButtonView onClick={onClick} />;
};
